import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const STATUSES = [
  { key: "open", label: "Open" },
  { key: "claimed", label: "Claimed" },
  { key: "in_progress", label: "In Progress" },
  { key: "submitted", label: "Submitted" },
  { key: "under_review", label: "Under Review" },
  { key: "completed", label: "Completed" },
  { key: "rejected", label: "Rejected" },
  { key: "expired", label: "Expired" },
  { key: "pending_approval", label: "Pending Approval" },
];

export const canCreateRequest = (user) =>
  !!user && ["owner", "department_admin", "contributor"].includes(user.role);

export const isOwner = (user) => user?.role === "owner";

export const isDeptAdmin = (user) => user?.role === "department_admin";

export const canAccessAdmin = (user) => isOwner(user) || isDeptAdmin(user);

/** Display label for role — Owner never shown as Admin. */
export const roleLabel = (userOrRole) => {
  const role = typeof userOrRole === "string" ? userOrRole : userOrRole?.role;
  if (role === "owner") return "Owner";
  if (role === "department_admin") return "Dept Admin";
  if (role === "contributor") return "Contributor";
  return role || "—";
};

export function statusLabel(s) {
  return STATUSES.find((x) => x.key === s)?.label || s;
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString(undefined, {
      month: "short", day: "numeric", year: "numeric",
    });
  } catch { return iso; }
}

export function timeAgo(iso) {
  if (!iso) return "";
  const t = new Date(iso).getTime();
  const diff = (Date.now() - t) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 86400 * 7) return `${Math.floor(diff / 86400)}d ago`;
  return new Date(iso).toLocaleDateString();
}

export function initials(name = "") {
  return name.split(" ").map((p) => p[0]).slice(0, 2).join("").toUpperCase();
}
